// extracted by mini-css-extract-plugin
export default {"root":"filters-bar_root__OaKJt","topBar":"filters-bar_topBar__K32fY","sorter":"filters-bar_sorter__gtHtq","bottomBar":"filters-bar_bottomBar__AUbEK"};